import {config} from '../../config';

export default function GoogleReviewBadge() {
  if (
    !config.googleReviewBadgeMerchantId ||
    config.googleReviewBadgeMerchantId === 'false'
  ) {
    return null;
  }

  return (
    <>
      <script
        src="https://apis.google.com/js/platform.js?onload=renderBadge"
        async
        defer
      ></script>

      <script
        dangerouslySetInnerHTML={{
          __html: `window.renderBadge = function() {
        var ratingBadgeContainer = document.createElement("div");
        document.body.appendChild(ratingBadgeContainer);
        window.gapi.load('ratingbadge', function() {
          window.gapi.ratingbadge.render(ratingBadgeContainer, {
            "merchant_id": ${config.googleReviewBadgeMerchantId},
            "position": "BOTTOM_LEFT"
          });
        });
      }`,
        }}
      />
    </>
  );
}
